import React from 'react';
import { Box } from '@mui/material';

import { WIDGET_BY_ID } from './registry';
import { SIZES } from './sizes';

const TEMPLATE_COLOR = { kpi: '#3182ce', breakdown: '#0d9488', list: '#805ad5', action: '#dd6b20', timeline: '#2f8c54', people: '#d69e2e', chart: '#48bb78', buttons: '#1a365d', banner: '#ed8936', search: '#64748b', clock: '#16a34a', kpigroup: '#3182ce', feedback: '#f6ad55', note: '#f59e0b' };

/** Schematic 12-column thumbnail of a preset layout (one white box per widget). */
export default function PresetThumb({ layout, width = 200 }) {
  const unit = width / 12;
  return (
    <Box sx={{ width, display: 'grid', gridTemplateColumns: 'repeat(12, 1fr)', gridAutoRows: `${unit * 0.55}px`, gap: '3px', p: 0.75, bgcolor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
      {layout.widgets.map((widget) => {
        const entry = WIDGET_BY_ID[widget.id];
        const size = SIZES[widget.size] || SIZES.M;
        return (
          <Box key={widget.id} sx={{ gridColumn: `span ${size.cols}`, gridRow: `span ${size.rows}`, bgcolor: '#fff', border: '1px solid #e2e8f0', borderRadius: '3px', overflow: 'hidden' }}>
            <Box sx={{ height: 3, bgcolor: TEMPLATE_COLOR[entry?.template] || '#cbd5e1' }} />
          </Box>
        );
      })}
    </Box>
  );
}
